import React, { Suspense, Fragment } from 'react';
import { createRoot } from 'react-dom/client';

import OperationalQuotas from '../modules/operationalQuotas/components/OperationalQuotas';

const componentMapper = {
    translations: React.lazy(() =>
        import(/* webpackChunkName: "translations" */ '../modules/translations/components/Translations')
    ),
    launch: React.lazy(() => import(/* webpackChunkName: "launch" */ '../modules/launch/components/Launch')),
    maxDiff: React.lazy(() => import(/* webpackChunkName: "max-diff" */ '../modules/maxDiff/components/MaxDiff')),
    operationalQuotas: OperationalQuotas,
};

const elementIdMapper = {
    translations: 'ts-translations-modal',
    importProject: 'ts-importProject-modal',
    launch: 'ti-launch-modal',
    maxDiff: 'ti-max-diff-modal',
    operationalQuotas: 'ti-operational-quotas-modal',
};

const singleModuleContainer = ['operationalQuotas', 'launch'];

/**
 * @param {'translations'|'launch'|'maxDiff'|'operationalQuotas'} moduleName
 */
export function initExternalModule(moduleName) {
    function renderModule(config) {
        let moduleContainer = document.getElementById(elementIdMapper[moduleName]);
        const Module = componentMapper[moduleName];

        // We don't need to create a container in each modules
        // So we create it here if it doesn't exist
        if (singleModuleContainer.includes(moduleName)) {
            if (moduleContainer) {
                return;
            }
            moduleContainer = document.createElement('div');
            moduleContainer.id = elementIdMapper[moduleName];
            document.body.appendChild(moduleContainer);
        }

        if (moduleContainer && Module) {
            const root = createRoot(moduleContainer);
            root.render(
                <Suspense fallback={<Fragment />}>
                    <Module config={config} />
                </Suspense>
            );
        }
    }

    return renderModule;
}

/**
 * @typedef {Object} LoadExternalScript
 * @prop {string} elementId
 * @prop {string} src
 *
 * @param {LoadExternalScript} options
 */
export function loadExternalModuleScript({ elementId, src }) {
    let node = document.getElementById(elementId);
    // Remove it if it already exists
    node?.parentNode.removeChild(node);

    // Load script
    node = document.createElement('script');
    node.type = 'text/javascript';
    node.async = true;
    node.src = src;
    node.id = elementId;

    const script = document.getElementsByTagName('script')[0];
    script.parentNode.insertBefore(node, script);
}
